// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoriasCliente_container__3lWd6","toolBar":"CategoriasCliente_toolBar__38e-a","columnAction":"CategoriasCliente_columnAction__1w1uG"};